export default {
  proveedores: [],
  proveedoresFiltros: [],
  totalProveedores: 0,
  proveedoresExport: [],
  proveedoresFiltersExport: [],
}